import { ChevronLeft } from "@tamagui/lucide-icons";
import { Pressable } from "react-native";
import { usePlanNavigation } from "../../plans/usePlanNavigation";

export const BackButton: React.FC<{
  goToFallback: () => void;
  beforeNavigate?: () => void;
}> = (props) => {
  const navigation = usePlanNavigation();

  const canGoBack = navigation.canGoBack();

  let goBackFunction = canGoBack ? navigation.goBack : undefined;

  if (!canGoBack) {
    goBackFunction = props.goToFallback;
  }

  if (!goBackFunction) {
    return null;
  }

  return (
    <Pressable
      onPress={() => {
        props.beforeNavigate?.();

        goBackFunction?.();
      }}
    >
      <ChevronLeft size="$size.normal" />
    </Pressable>
  );
};
